const type = 'OPEN_CANCEL_INVOICE_INSTALLMENT';

const openCancelInvoiceInstallment = () => ({
  type,
});

export { type };
export default openCancelInvoiceInstallment;
